import React from "react";
import "./biblioteca.css";
import { useEffect, useState, useRef } from "react";
import { useAxios } from "../../../hooks/useAxios";
import { useCounter } from "../../../hooks/useCounter";
import { useLibros, useLibros_Mov } from "./useLibros";
import { useTranslation } from "react-i18next";

import lib_v from "../../../assets/img/Lib_verde.png";
import lib_a from "../../../assets/img/Lib_azul.png";
import lib_b from "../../../assets/img/Lib_blanco2.png";

import imgplay from "../../../assets/img/Play.svg";

import fram1 from "../../../assets/img/preview_libro_blanco_ricardo_salinas.jpg";
import fram2 from "../../../assets/img/preview_libro_verde_ricardo_salinas.jpg";
import fram3 from "../../../assets/img/preview_libro_ricardo_salinas_azul.jpg";

import { libros12 } from "../../../assets/data/12libro";
import ir from "../../../assets/img/ir_acti.png";
import regresa from "../../../assets/img/regresa.png";
import regresa2 from "../../../assets/img/ir_izq.png";

import Modalibro from "../../../components/modalLibro/ModalLibro";
import VideoPopup from "../../popup/videopopup";
import axios from "axios";

const countBlog = 370;
const pagin = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const pagin_mov = [1, 2, 3, 4, 5];
const rut = "https://www.ricardosalinas.com/images/libros/";
const ruta = "";
const valor = "";

const Biblioteca = ({ books, contenido }) => {
  const { counter, increment, decrement, defaultValue } = useCounter(0);
  const { libros, isLoading, error } = useLibros({ counter, books });
  const { libros_mov, isLoading_mov, error_mov } = useLibros_Mov({
    counter,
    books,
  });
  const [t, i18n] = useTranslation("biblioteca");
  const liga_lang1 = "/" + i18n.language + "/LibroSociedades";
  const liga_lang2 = "/" + i18n.language + "/LibroLibertad";
  const liga_lang3 = "/" + i18n.language + "/LibroNegocios";

  const [book, setBook] = useState(null);
  const [bookMov, setBookMov] = useState(null);

  const [isVideoPopupOpen, setVideoPopupOpen] = useState(false);
  const [currentVideoId, setCurrentVideoId] = useState(null);

  const formatDate = (date) => {
    const options = { year: "numeric" };
    return new Date(date).toLocaleDateString(i18n.language, options);
  };

  const truncateText = (text, maxLength) => {
    try {
      if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...';
      } else {
        return text;
      }
    } catch (e) {
      return;
    }
  };

  const openVideoPopup = (videoId) => {
    setCurrentVideoId(videoId);
    setVideoPopupOpen(true);
  };

  const closeVideoPopup = () => {
    setVideoPopupOpen(false);
  };

  useEffect(() => {
    if (libros) {
      setBook(libros);
    }
  }, [libros]);

  useEffect(() => {
    if (libros_mov) {
      setBookMov(libros_mov);
    }
  }, [libros_mov]);


  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [variable1, setVariable1] = useState("");
  const [variable2, setVariable2] = useState("");
  const [variable3, setVariable3] = useState("");
  const [variable4, setVariable4] = useState("");
  const [variable5, setVariable5] = useState("");
  const [variable6, setVariable6] = useState("");
  const [variable7, setVariable7] = useState("");
  const [variable8, setVariable8] = useState("");
  const [variable9, setVariable9] = useState("");

  const openModal2 = (
    value1,
    value2,
    value3,
    value4,
    value5,
    value6,
    value7,
    value8,
    value9
  ) => {

    setVariable1(value1);
    setVariable2(value2);
    setVariable3(value3);
    setVariable4(value4);
    setVariable5(value5);
    setVariable6(value6);
    setVariable7(value7);
    setVariable8(value8);
    setVariable9(value9);
    setIsModalOpen2(true);
  };

  const closeModal2 = () => {
    setIsModalOpen2(false);
  };

  const fechData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/library/nbooks?offset=0&next=200&sitioid=2&lenguaje=${i18n.language}`
      );
      const data = response.data;
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const elementosMostrados = 6;
  const [totalElementos, setTotalElementos] = useState([]);
  const totalPaginas = Math.ceil(totalElementos.length / elementosMostrados);
  const [paginaActual, setPaginaActual] = useState(1);
  const [paginasVisibles, setPaginasVisibles] = useState([]);

  const totallib = counter * 12;

  useEffect(() => {
    const elementos = async () => {
      const data = await fechData();
      setTotalElementos(data);
    };
    elementos();
  }, []);

  useEffect(() => {
    const generarPaginasVisibles = () => {
      let paginaInicial, paginaFinal;

      // Caso 1: Menos de 5 páginas en total
      if (totalPaginas <= 5) {
        paginaInicial = 1;
        paginaFinal = totalPaginas;
      } else {
        // Caso 2: Más de 5 páginas en total
        if (paginaActual < 5) {
          // Estamos en las primeras 5 páginas
          paginaInicial = 1;
          paginaFinal = 5;
        } else if (paginaActual + 4 >= totalPaginas) {
          // Estamos en las últimas 5 páginas
          paginaInicial = totalPaginas - 4;
          paginaFinal = totalPaginas;
        } else {
          // Estamos en el medio de las páginas
          paginaInicial = paginaActual - 2;
          paginaFinal = paginaActual + 2;
        }
      }

      // Generar la lista de páginas visibles
      const paginas = [];
      for (let i = paginaInicial; i <= paginaFinal; i++) {
        paginas.push(i);
      }

      setPaginasVisibles(paginas);
    };

    generarPaginasVisibles();
  }, [paginaActual, totalPaginas]);

  const nextPage = () => {
    setPaginaActual(
      paginaActual === totalPaginas ? totalPaginas : paginaActual + 1
    );
  };

  const prevPage = () => {
    setPaginaActual(paginaActual === 1 ? 1 : paginaActual - 1);
  };


  const [loadingimg, setLoadingimg] = useState(true);
  const var_img = useRef(0);
  const imageLoaded = () => {
    var_img.current += 1;
    if (var_img.current >= 12) {
      setLoadingimg(false);
    }
  }


  return (
    <div class="biblio_cont">
      <VideoPopup
        isOpen={isVideoPopupOpen}
        onClose={closeVideoPopup}
        videoURL={currentVideoId}
      />
      <div class="contenedor_bi ">
        <div class="row1_bi">
          <p class="titulo_bi">{t("header.titulo")}</p>
          <p class="descrip_bi">
            <div
              dangerouslySetInnerHTML={{ __html: t("header.descripcion") }}
            />
          </p>
        </div>

        <img src={lib_a} alt="Imagen ideas" class="imgG3_bi " />
        <div class="div_bot1_bi3">
          <a class="buton1_bi3" href={liga_lang3}>
            {t("header.button_saber")}
          </a>
        </div>
        <div class="div_bot2_bi3">
          <a
            class="buton2_bi3"
            target="_blank"
            href="https://www.elektra.mx/ideas-que-transforman-negocios-para-cambiar-al-mundo-100001071/p"
          >
            {t("header.button_comprar")}
          </a>
        </div>
        <div class="col3" />

        <div class="row2_bi">
          <div class="col1_bi">
            <img src={lib_b} alt="Imagen ideas" class="imgG1_bi  " />
          </div>
          <div class="col2_bi">
            <img src={lib_v} alt="Imagen ideas" class="imgG2_bi " />
          </div>
        </div>

        <div class="row3_bi">
          <div class="col1_bi2">
            <div class="div_bot1_bi">
              <a class="buton1_bi" href={liga_lang2}>
                {t("header.button_saber")}
              </a>
            </div>
            <div class="div_bot2_bi">
              <a
                class="buton2_bi"
                target="_blank"
                href="https://www.amazon.com.mx/Ideas-Sobre-Libertad-Cambian-Mundo/dp/6079900653/ref=sr_1_1?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=1SDYRDQWK45Z1&dchild=1&keywords=ricardo+salinas&qid=1633357240&sprefix=ricardo+anaya%2Caps%2C221&sr=8-1"
              >
                {t("header.button_comprar")}
              </a>
            </div>
          </div>
          <div class="col2_bi2">
            <div class="div_bot1_bi2">
              <a class="buton1_bi2" href={liga_lang1}>
                {t("header.button_saber")}
              </a>
            </div>
            <div class="div_bot2_bi2">
              <a
                class="buton2_bi2"
                target="_blank"
                href="https://www.amazon.com.mx/dp/6079900696/ref=redir_mobile_desktop/135-4069732-7734861?_encoding=UTF8&qid=&ref_=tmm_pap_swatch_0&sr="
              >
                {t("header.button_comprar")}
              </a>
            </div>
          </div>
        </div>

        <div class="row1_rec ">
          <p class="titulo_rec">{t("recomienda.titulo")}</p>
        </div>
        <div class="row2_rec escritorio">
          <div
            class="col1_rec"
            onClick={() =>
              openVideoPopup(
                "https://www.youtube.com/embed/jlS9EmHZKLM?si=tqGtWd_7tORQvpTs"
              )
            }
          >
            <img src={fram1} alt="Imagen ideas" class="imgG2_rec" />
            <img class="recomendado_img_play" src={imgplay} />
          </div>

          <div class="col2_rec">
            <div
              class="col2r1_rec"
              onClick={() =>
                openVideoPopup(
                  "https://www.youtube.com/embed/J8_6RIyl4W8?si=pbcxwDX3LyWX0Wj2"
                )
              }
            >
              <img src={fram2} alt="Imagen ideas" class="imgG3_rec " />
              <img class="recomendado_img_play" src={imgplay} />
            </div>
            <div
              class="col2r2_rec"
              onClick={() =>
                openVideoPopup(
                  "https://www.youtube.com/embed/s5zMXNyhV6g?si=qXZpg93FUk5K7zdl"
                )
              }
            >
              <img src={fram3} alt="Imagen ideas" class="imgG3_rec " />
              <img class="recomendado_img_play" src={imgplay} />
            </div>
          </div>
        </div>
        <div class="row2_rec movil">
          <div
            class="col1_rec_mov"
            onClick={() =>
              openVideoPopup(
                "https://www.youtube.com/embed/jlS9EmHZKLM?si=tqGtWd_7tORQvpTs"
              )
            }
          >
            <img src={fram1} alt="Imagen ideas" class="imgG2_rec_mov " />
            <img class="recomendado_img_play" src={imgplay} />
          </div>

          <div class="col2_rec_mov">
            <div
              class="col2r1_rec_mov"
              onClick={() =>
                openVideoPopup(
                  "https://www.youtube.com/embed/J8_6RIyl4W8?si=pbcxwDX3LyWX0Wj2"
                )
              }
            >
              {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/rH2XXdt83BU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
              <img src={fram2} alt="Imagen ideas" class="imgG3_rec_mov " />
              <img class="recomendado_img_play" src={imgplay} />
            </div>
            <div
              class="col2r2_rec_mov"
              onClick={() =>
                openVideoPopup(
                  "https://www.youtube.com/embed/s5zMXNyhV6g?si=qXZpg93FUk5K7zdl"
                )
              }
            >
              {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/rH2XXdt83BU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
              <img src={fram3} alt="Imagen ideas" class="imgG3_rec_mov " />
              <img class="recomendado_img_play" src={imgplay} />
            </div>
          </div>
        </div>

        <div class="row1_bi dista">
          <div class="col1">
            <p class="titulo_bi">{t("biblioteca.titulo")}</p>
            <p class="descrip_bi2">{t("biblioteca.descripcion")}</p>
            <p class="descrip_bi3">{t("biblioteca.conocelos")}</p>

            <p class="vid_lib_r"><video poster="https://ricardosalinas.com/blog/images/Segmento-8.jpg" controls>
              <source src="https://ricardosalinas.com/blog/images/Mis-libros-de-cabecera.mp4" type="video/mp4" />
              <source src="https://ricardosalinas.com/blog/images/Mis-libros-de-cabecera.webm" type="video/webm" />
            </video></p>

          </div>
        </div>

        <div class="row1_bp">
          <p class="result_bp">
            {t("biblioteca.mostrando")} {((counter) * 12) + (book ? book.length : 0)}{t("biblioteca.of")}{(totalElementos ? totalElementos.length : 120)}
            {t("biblioteca.resultados")}
          </p>
        </div>

        <div class="row2_bp escritorio">
          <div style={{ display: loadingimg ? "block" : "none" }}>
            <h1 style={{ marginLeft: "45%" }}> Cargando... </h1>
          </div>
          <div style={{ display: loadingimg ? "none" : "flex" }} class="list_content--items_bp">
            {isLoading || book === null ? (
              <h1>Esta cargando...</h1>
            ) : (
              <>
                {book.map((item, index) => (
                  <div class="card" key={index}>
                    <div class="front">
                      {/* Contenido de la parte delantera de la tarjeta */}
                      <img
                        class="imgG_bp"
                        src={rut + item.imagen}
                        onLoad={imageLoaded}
                        alt={item.imagen.substring(0, item.imagen.length - 4)}
                      />
                      <div class="cinta_bp">
                        <p class="tit_bp">{item.titulo.split(":")[0]}</p>
                      </div>
                    </div>

                    <div class="back">
                      {/* Contenido de la parte trasera de la tarjeta */}
                      <p class="titu_bp">{item.titulo.split(":")[0]}</p>
                      <p class="desc_bp">
                        {item.descripcion.substring(0, 155) + "..."}
                      </p>
                      <p class="alineIzq_ub_bp aut_bp">{item.autor}</p>
                      <p class="alineIzq_ub_bp daut_bp">{truncateText(item.editorial, 27)}</p>
                      <p class="alineIzq_ub_bp fh_bp">
                        {formatDate(item.fecha)}
                      </p>

                      <div class="div_bot1_bp">
                        {/* Botón con onClick y uso del índice */}
                        <button
                          class="buton_bp"
                          onClick={() =>
                            openModal2(
                              rut + item.imagen,
                              item.imagen.substring(0, item.imagen.length - 4),
                              item.titulo,
                              item.descripcion,
                              item.autor,
                              item.editorial,
                              formatDate(item.fecha),
                              item.blog,
                              i18n.language
                            )
                          }
                        >
                          <label>{t("biblioteca.ver-mas")}</label>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>

          <div id="column-left_bp">

            <div class="row6_bp">
              {counter > 0 && book === null ? (
                <div></div>
              ) : (
                <img
                  class="imgPag_bp_dr"
                  onClick={() => {
                    if (counter < 9) {
                      var_img.current = 0;
                      setLoadingimg(true); 
                      increment();
                    }
                  }}
                  src="/assets/imgs/detalle_blog/arrow.png"
                />
              )}
            </div>
            <div class="row6_bp">
              {counter > 0 ? (
                <img
                  class="imgPag_bp"
                  onClick={() => {
                    var_img.current = 0;
                    setLoadingimg(true);
                    decrement()
                  }}
                  src="/assets/imgs/detalle_blog/arrow.png"
                />
              ) : (
                <div></div>
              )}
            </div>
            {pagin.map((item, index) => (
              <div div class="row6_bp">
                <p className={
                  counter === index ? "numeros_paginado_idea_corta nume" : "nume"} key={index} onClick={() => {
                    var_img.current = 0;
                    setLoadingimg(true);
                    defaultValue(index)
                    }}>
                  {item}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div class="row2_bp movil">
          {/* Contenedor de paginacion */}
          <div class="column-arriba">
            <p class="result_bp_mov">
              {t("biblioteca.mostrando")} {((counter) * 6) + (book ? book.slice(0, 6).length : 0)}{t("biblioteca.of")}{(totalElementos ? totalElementos.length : 120)}
              {t("biblioteca.resultados")}
            </p>
            <div class="contenedor-paginacion-movil">
              
              {/* Boton para ir hacia atras */}
              <div className="contenedor-btn">
                <img
                  className="imagen-izquierda"
                  onClick={() => {
                    var_img.current = 0;
                    setLoadingimg(true);
                    decrement();
                    prevPage();
                  }}
                  src={`${paginaActual > 1
                    ? "/assets/imgs/detalle_blog/arrow.png"
                    : "/assets/imgs/detalle_blog/regresa.png"
                    }`}
                  disabled={paginaActual === 1 ? true : false}
                />
              </div>

              {/* Ellipisis para mostrar si es mas de las 5 primeras */}
              {paginaActual >= 5 && <a>...</a>}

              {/* Paginas visibles */}
              {paginasVisibles.map((page) => (
                <a
                  key={page}
                  className={`${page === paginaActual ? "numeros_paginado_idea_corta_movil" : ""}`}
                  onClick={() => {
                    var_img.current = 0;
                    setLoadingimg(true);
                    defaultValue(page - 1);
                    setPaginaActual(page);
                  }}
                >
                  {page}
                </a>
              ))}
              {/* Ellipisis para mostrar si no es las 5 ultimas */}
              {paginaActual < totalPaginas - 4 && <a>...</a>}

              {/* Boton para ir hacia adelante */}
              <div className="contenedor-btn">
                <img
                  className="imagen-derecha"
                  onClick={() => {
                    if (counter + 1 < totalPaginas) {
                      var_img.current = 0;
                      setLoadingimg(true);
                      increment();
                      nextPage();
                    }
                  }}
                  src={`${paginaActual === totalPaginas
                    ? "/assets/imgs/detalle_blog/ir_2.png"
                    : "/assets/imgs/detalle_blog/ir_acti.png "
                    }`}
                  disabled={paginaActual === totalPaginas ? true : false}
                />
              </div>
            </div>
          </div>

          <div style={{ display: loadingimg ? "block" : "none" }}>
            <h1 style={{ marginLeft: "45%" }}> Cargando... </h1>
          </div>
          <div style={{ display: loadingimg ? "none" : "flex" }} class="list_content--items_bp">
            {isLoading_mov || bookMov === null ? (
              <h1>Esta cargando...</h1>
            ) : (
              <>
                {bookMov.map((item, index) => (
                  <div class="card" key={index}>
                    <div class="front">
                      <img
                        class="imgG_bp"
                        src={rut + item.imagen}
                        onLoad={imageLoaded}
                        alt={item.imagen.substring(0, item.imagen.length - 4)}
                      />
                      <div class="cinta_bp">
                        <p class="tit_bp">{item.titulo.split(":")[0]}</p>
                      </div>
                    </div>
                    <div class="back">
                      <p class="titu_bp">{item.titulo.split(":")[0]}</p>
                      <p class="desc_bp">
                        {item.descripcion.substring(0, 90) + "..."}
                      </p>
                      <p class="alineIzq_ub_bp aut_bp">{truncateText(item.autor, 25)}</p>
                      <p class="alineIzq_ub_bp daut_bp">{truncateText(item.editorial, 21)}</p>
                      <p class="alineIzq_ub_bp fh_bp">
                        {" "}
                        {formatDate(item.fecha)}{" "}
                      </p>
                      <div class="div_bot1_bp">
                        {/* <a class="buton_bp" target="_blank" href="#">{(t('biblioteca.ver-mas'))}</a> */}

                        <button
                          class="buton_bp opciones_bon_2"
                          onClick={() =>
                            openModal2(
                              rut + item.imagen,
                              item.imagen.substring(0, item.imagen.length - 4),
                              item.titulo,
                              item.descripcion,
                              item.autor,
                              item.editorial,
                              formatDate(item.fecha),
                              item.blog,
                              i18n.language
                            )
                          }
                        >
                          <label>{t("biblioteca.ver-mas")}</label>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>

        <div class="row3_bp">
          <p class="result_bp">
            {t("biblioteca.mostrando")} {((counter) * 12) + (book ? book.length : 0)}{t("biblioteca.of")}{(totalElementos ? totalElementos.length : 120)}
            {t("biblioteca.resultados")}
          </p>
          <p class="result_bp_mov">
            {t("biblioteca.mostrando")} {((counter) * 6) + (book ? book.slice(0, 6).length : 0)}{t("biblioteca.of")}{(totalElementos ? totalElementos.length : 120)}
            {t("biblioteca.resultados")}
          </p>
        </div>
      </div>

      {/* <div className="contenedor_bi">
                <div className="row4_LB">
                    <div className="div_bot2_LB">
                        <a className="buton2_LB" target="_blank" href="#">{(t('filtro.mas-entradas'))}</a>
                    </div>
                </div>
            </div> */}

      <Modalibro
        isOpen={isModalOpen2}
        closeModal={closeModal2}
        variable1={variable1} //ruta con imagen
        variable2={variable2} //titulo
        variable3={variable3} //descripcion
        variable4={variable4} //autor
        variable5={variable5} //editorial
        variable6={variable6} //año
        variable7={variable7} //año
        variable8={variable8} //año
        variable9={variable9} //año

      // hdksjfjkds
      />
    </div>
  );
};
export default Biblioteca;
